/* D2 — garde visuelle d'un System : si non souscrit, mur propre « System non
   activé » (zéro fuite de données, zéro scaffolding du System). Le backend
   refuse déjà (fail-close D1) : cette garde évite seulement les pages d'erreur. */
import { Link } from "react-router-dom";
import { Lock, ArrowLeft, Sparkles } from "lucide-react";
import { SYSTEM_DEFS, useSystems } from "@/lib/systems";

function SystemNotEnabled({ system }) {
  const def = SYSTEM_DEFS.find((d) => d.id === system);
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="system-not-enabled">
      <div className="max-w-md w-full border border-white/10 rounded-xl bg-[#111113] p-10">
        <div className="w-12 h-12 rounded-lg border border-white/10 bg-white/[0.04] flex items-center justify-center mb-6">
          <Lock className="w-5 h-5 text-zinc-400" />
        </div>
        <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 mb-2">
          {def?.label || system}
        </div>
        <h2 className="noam-display text-2xl font-bold tracking-tight text-white mb-3">
          System non activé
        </h2>
        <p className="text-sm text-white/60 leading-relaxed mb-8">
          Votre organisation n'a pas activé ce System. Aucune donnée n'est
          accessible. Contactez Constant Partners pour l'activer.
        </p>
        <div className="flex items-center gap-3">
          <Link
            to="/app/hub"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-[#378ADD] text-white text-sm font-medium hover:bg-[#4a99e6] transition-colors focus:ring-2 focus:ring-[#378ADD] focus:outline-none"
            data-testid="system-not-enabled-back-hub"
          >
            <ArrowLeft className="w-4 h-4" /> Retour au hub NOAM
          </Link>
          <Link
            to="/app/hub"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-white/10 text-zinc-300 text-sm hover:bg-white/5 transition-colors"
            data-testid="system-not-enabled-discover"
          >
            <Sparkles className="w-4 h-4" /> Découvrir
          </Link>
        </div>
      </div>
    </div>
  );
}

export const SystemGuard = ({ system, children }) => {
  const { systems, loading } = useSystems();
  if (loading) return null;
  if (!systems.includes(system)) return <SystemNotEnabled system={system} />;
  return children;
};

export default SystemGuard;
